import {
  FETCH_KIOSK_SURVEYS_PENDING,
  FETCH_KIOSK_SURVEYS_SUCCESS,
  FETCH_KIOSK_SURVEYS_FAIL,
  RESET_KIOSK_SURVEYS,
  SET_KIOSK_ERROR,
  RESET_KIOSK_ERROR,
  RESET_APP,
} from '../../constants/action_types';

const defaultState = {
  uniqueId: null,
  surveyList: [],
  error: '',
  isLoading: false,
};

const kioskReducer = (state = defaultState, action) => {
  switch (action.type) {
    case FETCH_KIOSK_SURVEYS_PENDING:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_KIOSK_SURVEYS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        uniqueId: action.uniqueId,
        surveyList: action.surveyList,
        error: '',
      };
    case FETCH_KIOSK_SURVEYS_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.msg, // TODO: maybe we want to handle this in the global notifications?
      };
    case RESET_KIOSK_SURVEYS:
      return {
        ...state,
        surveyList: [],
      };
    case SET_KIOSK_ERROR:
      return {
        ...state,
        error: action.msg,
      };
    case RESET_KIOSK_ERROR:
      return {
        ...state,
        error: '',
      };
    case RESET_APP:
      return defaultState;
    default:
      return state;
  }
};

export default kioskReducer;
